import qs from "querystring";
import axios from "axios";

class Api {
    constructor() {
        this.http = axios.create({
            baseURL: this.getBaseUrl(),
            headers: {},
        });
    }

    getBaseUrl() {
        return process.env.VUE_APP_BACKEND_URL;
    }

    login(username, password) {
        return this.http.post(
            "/autenticacao/login",
            qs.stringify({ username: username, password: password })
        );
    }

    updateInfo(name, email, password, token) {
        return this.http.post(
            "/cadastro/atualizar",
            qs.stringify({
                name: name,
                email: email,
                password: password,
                token: token,
            })
        );
    }

    getMyCards(token) {
        return this.http.get("/pessoa/fichas", {
            headers: {
                token: token,
            },
        });
    }

    getMyContexts(token) {
        return this.http.get("/pessoa/contextos", {
            headers: {
                token: token,
            },
        });
    }

    getMySections(token, id) {
        return this.http.get("/pessoa/secoes/" + id, {
            headers: {
                token: token,
            },
        });
    }

    getMyProducts(token) {
        return this.http.get("/loja/produtos", {
            headers: {
                token: token,
            },
        });
    }

    getMyInfo(token) {
        return this.http.get("/cadastro/dados/", {
            headers: {
                token: token,
            },
        });
    }

    getMyOrders(token) {
        return this.http.get("/loja/pedidos", {
            headers: {
                token: token,
            },
        });
    }

    getCardsFromSection(token, id) {
        return this.http.get("/pessoa/fichas/" + id, {
            headers: {
                token: token,
            },
        });
    }

    getCard(token, id) {
        return this.http.get("/fichas/" + id, {
            headers: {
                token: token,
            },
        });
    }

    serchCard(token, word) {
        return this.http.get("/pesquisa/" + word, {
            headers: {
                token: token,
            },
        });
    }

    validateToken(token) {
        return this.http.post(
            "/autenticacao/valida",
            qs.stringify({ token: token })
        );
    }

    renewToken(token) {
        return this.http.post(
            "/autenticacao/renova",
            qs.stringify({ token: token })
        );
    }

    validateProducts(token, products) {
        var cards = "[";
        var t = products.length;
        for (var i = 0; i < t; i++) {
            cards += "" + products[i].id;
            if (i != t - 1) {
                cards += ",";
            }
        }
        cards += "]";
        return this.http.get("/loja/valida", {
            headers: { token: token, fichas: cards },
        });
    }

    completeSell(token, products, paypalid) {
        var cards = "[";
        var t = products.length;
        for (var i = 0; i < t; i++) {
            cards += "" + products[i].id;
            if (i != t - 1) {
                cards += ",";
            }
        }
        cards += "]";
        return this.http.post(
            "/loja/venda/paypal",
            qs.stringify({ token: token, fichas: cards, paypal: paypalid })
        );
    }
}

export default new Api();
